module.exports = __webpack_public_path__ + "static/media/troph.da5a0514.png";